import AppTable from '@/components/AppTable';
import { formatNumber } from '@/utils/formatters';
import { Table } from 'antd';
import React from 'react';

const overviewColsSub = [
  {
    title: 'Package',
    dataIndex: 'package_code',
    key: 'package_code',
    fixed: 'left',
    width: '15%',
  },
  {
    title: 'Register',
    children: [
      {
        title: 'Total',
        dataIndex: 'register_total',
        key: 'register_total',
        render: (value) => (value > 0 ? formatNumber(value) : 0),
      },
      {
        title: 'Success',
        dataIndex: 'register_success',
        key: 'register_success',
        render: (value) => (value > 0 ? formatNumber(value) : 0),
      },
      {
        title: 'Fail',
        dataIndex: 'register_fail',
        key: 'register_fail',
        render: (value) => (value > 0 ? formatNumber(value) : 0),
      },
      {
        title: 'Rate',
        dataIndex: 'register_rate',
        key: 'register_rate',
        render: (value) => (value !== '0%' ? value : '0.00%'),
      },
    ],
  },
  {
    title: 'Renew',
    children: [
      {
        title: 'Total',
        dataIndex: 'renew_total',
        key: 'renew_total',
        render: (value) => (value > 0 ? formatNumber(value) : 0),
      },
      {
        title: 'Success',
        dataIndex: 'renew_success',
        key: 'renew_success',
        render: (value) => (value > 0 ? formatNumber(value) : 0),
      },
      {
        title: 'Fail',
        dataIndex: 'renew_fail',
        key: 'renew_fail',
        render: (value) => (value > 0 ? formatNumber(value) : 0),
      },
      {
        title: 'Rate',
        dataIndex: 'renew_rate',
        key: 'renew_rate',
        render: (value) => (value !== '0%' ? value : '0.00%'),
      },
    ],
  },
  {
    title: 'Cancel',
    children: [
      {
        title: 'Total',
        dataIndex: 'cancel_total',
        key: 'cancel_total',
        render: (value) => (value > 0 ? formatNumber(value) : 0),
      },
      {
        title: 'User',
        dataIndex: 'cancel_user_total',
        key: 'cancel_user_total',
        render: (value) => (value > 0 ? formatNumber(value) : 0),
      },
      {
        title: 'System',
        dataIndex: 'cancel_sys_total',
        key: 'cancel_sys_total',
        render: (value) => (value > 0 ? formatNumber(value) : 0),
      },
    ],
  },
];

const overviewColsRetail = [
  {
    title: 'Package',
    dataIndex: 'package_code',
    key: 'package_code',
    fixed: 'left',
    width: '15%',
  },
  {
    title: 'Total',
    dataIndex: 'total',
    key: 'total',
    render: (value) => (value > 0 ? formatNumber(value) : 0),
  },
  {
    title: 'Success',
    dataIndex: 'success',
    key: 'success',
    render: (value) => (value > 0 ? formatNumber(value) : 0),
  },
  {
    title: 'Fail',
    dataIndex: 'fail',
    key: 'fail',
    render: (value) => (value > 0 ? formatNumber(value) : 0),
  },
  {
    title: 'Rate',
    dataIndex: 'rate',
    key: 'rate',
    render: (value) => (value !== '0%' ? value : '0.00%'),
  },
];

function OverviewTable({ dataSource, loading, packageOption, totals }) {
  return (
    <div className="mt-4 space-y-4 w-full">
      <AppTable
        disableColumnVisibility={true}
        tableTitle={<p className="font-medium">Overview statistic table</p>}
        columns={packageOption === 1 ? overviewColsSub : overviewColsRetail}
        dataSource={Array.isArray(dataSource) ? dataSource : [dataSource]}
        hasPagination={false}
        loading={loading}
        summary={() => {
          // Use passed totals instead of recalculating
          if (!totals) return null;

          if (packageOption === 2) {
            const values = [
              'Total',
              totals.total || 0,
              totals.success || 0,
              totals.fail || 0,
              totals.rate || '0.00%',
            ];

            return (
              <Table.Summary fixed>
                <Table.Summary.Row>
                  {values.map((value, index) => (
                    <Table.Summary.Cell
                      key={index}
                      index={index}
                      align="center"
                      className="font-medium"
                    >
                      {typeof value === 'number' ? formatNumber(value) : value}
                    </Table.Summary.Cell>
                  ))}
                </Table.Summary.Row>
              </Table.Summary>
            );
          } else {
            const values = [
              'Total',
              totals.register_total,
              totals.register_success,
              totals.register_fail,
              totals.register_rate,
              totals.renew_total,
              totals.renew_success,
              totals.renew_fail,
              totals.renew_rate,
              totals.cancel_total,
              totals.cancel_user_total,
              totals.cancel_sys_total,
            ];

            return (
              <Table.Summary fixed>
                <Table.Summary.Row>
                  {values.map((value, index) => (
                    <Table.Summary.Cell
                      key={index}
                      index={index}
                      align="center"
                      className="font-medium"
                    >
                      {typeof value === 'number' ? formatNumber(value) : value}
                    </Table.Summary.Cell>
                  ))}
                </Table.Summary.Row>
              </Table.Summary>
            );
          }
        }}
      />
    </div>
  );
}

export default OverviewTable;
